<template>
  <!-- banner topo-->
  <div v-if="bannerTopo != ''" class="slider-area">
    <div class="slider-height2 slider-bg2 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="offset-xl-1 col-xl-5 col-lg-5 col-md-5">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END banner topo-->

  <!-- Politicas e termos -->
  <div class="services-area2 section-padding">
    <div class="container">
      <div class="row">

        <!-- menu -->
        <div class="col-lg-3 col-md-6 col-sm-8 order-lg-1">
          <div class="filter-widget" style="margin-bottom: 80px;">
            <h4 class="fw-title strong">Políticas e Termos</h4><br>
            <ul class="filter-catagories">
              <li v-for="menu in informacoes" :key="menu.itiId">
                <a href="#" @click.prevent="carregaTexto(menu.itiId)">
                  <p>{{ menu.itiNome }}</p>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- titulo e texto -->
        <div v-if="informacao != ''" class="col-lg-9  order-lg-2" style=" margin-bottom: 100px;">
          <h3>{{ informacao[0].itiNome }}</h3><br>
          <p v-html="informacao[0].itiResumo1"></p>
        </div>
      </div>
    </div>
  </div>
  <!-- politicas e termos final -->

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { useRoute } from 'vue-router';

export default {
  name: 'InformacoesView',
  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    informacoes: [],
    informacao: [],
  }),

  methods: {
    carregaMetas(texto, titulo) {
      useHead({
        title: 'FiançAqui Garantidora - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "FiançAqui Garantidora" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
          { name: "keywords", content: "" }
        ],
      })
    },
    carregaTexto(value) {
      this.informacao = this.informacoes.filter(x => x.itiId == value)
    },
  },

  created() {
    this.carregaMetas();

    axios.get('/Process/InsInstitucional/institucional/53/topoinformacoes/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    axios.get('/Process/InsInstitucional/institucional/54/listadasinformacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        if (this.id) {
          this.carregaTexto(this.id);
        }
        else {
          this.carregaTexto(this.informacoes[0].itiId);
        }
        console.log('informacoes')
        console.log(this.informacoes)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>